import styled from 'styled-components';
import colors from 'theme/colors';

export const FileContainerStyled = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 8.375rem;
  left: 1.5rem;
  top: 18.438rem;
  background: ${colors.white};
  box-shadow: 0 0.063rem 0 rgba(0, 0, 0, 0.07), 0 -0.063rem 0 rgba(0, 0, 0, 0.07);
  border-radius: 0.125rem;
  padding: 0 1rem;
`;

export const FileItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .ant-tag {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const FileTypeStatusContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
`;

export const TypeStatusStyled = styled.div`
  display: flex;
  justify-content: space-between;
  width: 16.188rem;
  height: 1.375rem;
  border: 0.063rem solid rgba(0, 0, 0, 0.07);
  box-sizing: border-box;
  border-radius: 0.25rem;
  margin-top: 0.625rem;
  padding-left: 0.313rem;
  span:nth-child(1) {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 0.75rem;
    line-height: 1.25rem;
    color: rgba(0, 0, 0, 0.65);
  }
  .ant-tag {
    margin-right: 0 !important;
  }
`;

export const FileDateStyled = styled.div`
  margin-top: 0.438rem;
  margin-left: 4.25rem;
`;
